export function isCurrentBatchJobId(activeJobId, candidateJobId) {
  const active = String(activeJobId || '').trim();
  const candidate = String(candidateJobId || '').trim();
  return Boolean(active && candidate && active === candidate);
}
